var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminLayout',{attrs:{"scroll-body":""}},[(_vm.loading)?_c('v-skeleton-loader',{attrs:{"type":"article"}}):(_vm.ready)?_c('BookingEdit',{attrs:{"booking":_vm.booking,"bookables":_vm.bookables,"workflow":_vm.workflow,"group-booking":_vm.groupBooking},on:{"saved":_vm.onSaved,"cancel":_vm.goBack}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }